module.exports = __webpack_public_path__ + "47716f6e8a01f0bbfdfc2209be00ee61.MP3";